module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#photostory",
      toString: function () {
        return this.url;
      }
    }